import { useEffect, useState } from "react";

/** Time-based progress for loads without discrete milestones (caps below 100%). */
export function useSimulatedLoadingPercent(active: boolean, cap = 88): number {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if (!active) {
      setPercent(0);
      return;
    }

    setPercent(0);
    const start = Date.now();
    const id = window.setInterval(() => {
      const elapsed = Date.now() - start;
      const next = Math.min(cap, Math.round(cap * (1 - Math.exp(-elapsed / 4000))));
      setPercent(next);
    }, 120);

    return () => window.clearInterval(id);
  }, [active, cap]);

  return percent;
}
